import axios from 'axios'

import {
    baseAPIPath,
    authRequestInterceptors,
    authResponseSuccessInterceptors,
    authResponseErrorInterceptors
} from './configVariables'

const instance = axios.create({
    baseURL: `${baseAPIPath}/force_rank_vertical`
})

instance.interceptors.request.use(authRequestInterceptors)
instance.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors)

export default instance
